module.exports = __webpack_public_path__ + "static/img/s408.f383820.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s408.png
// module id = 560
// module chunks = 3